<template>
  <div>
    <div v-if="row[prop] && row[prop].length === 1" class="phone-s-r">
      <div class="phone-s">
        <div class="phone-a-c">
          <phone-com :comPhone="row[prop][0].phone"
                     :vagaryPhone="Object.hasOwnProperty.call(row[prop][0], 'vagary_phone') ? row[prop][0].vagary_phone : false"
                     class="phone-com" />
          <el-tooltip class="item" effect="dark" content="外呼" placement="top">
            <i @click="
            call(
                row[prop][0].vagary_phone ? row[prop][0].vagary_phone : row[prop][0].phone
            )
            " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
          </el-tooltip>
        </div>
        <div>
                                <span>
                                    {{ row[prop][0].province }} {{ row[prop][0].city }}
                                </span>
          <el-tag type="success" effect="dark" size="mini"
                  v-if="row[prop][0].weixinStatus && row[prop][0].weixinStatus === '活跃号'">
            是微信
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini"
                  v-else-if="row[prop][0].weixinStatus && row[prop][0].weixinStatus !== '活跃号'">
            {{ row[prop][0].weixinStatus }}
          </el-tag>
        </div>
        <span>
                                手机号姓名: {{ row[prop][0].name }}
                            </span>
      </div>
      <div>
        <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                    v-if="row.is_not_refreshed === 1">
          <i class="el-icon-refresh r-icon r-icon-ref"
             @click="loadPhoneInformation(row.id)"></i>
        </el-tooltip>
      </div>
    </div>
    <div v-if="row[prop] && row[prop].length > 1" class="phone-s-r">
      <div class="phone-s">
        <div class="phone-a-c">
          <phone-com class="phone-com" :comPhone="row[prop][0].phone"
                     :vagaryPhone="Object.hasOwnProperty.call(row[prop][0], 'vagary_phone') ? row[prop][0].vagary_phone : false" />
          <el-tooltip class="item" effect="dark" content="外呼" placement="top">
            <i @click="
            call(
                row[prop][0].vagary_phone ? row[prop][0].vagary_phone : row[prop][0].phone
            )
            " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
          </el-tooltip>
        </div>
        <div>
                                <span>
                                    {{ row[prop][0].province }} {{ row[prop][0].city }}
                                </span>
          <el-tag type="success" effect="dark" size="mini"
                  v-if="row[prop][0].weixinStatus && row[prop][0].weixinStatus === '活跃号'">
            是微信
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini"
                  v-else-if="row[prop][0].weixinStatus && row[prop][0].weixinStatus !== '活跃号'">
            {{ row[prop][0].weixinStatus }}
          </el-tag>
        </div>
        <span>
                                手机号姓名: {{ row[prop][0].name }}
                            </span>
      </div>
      <div>
        <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                    v-if="row.is_not_refreshed === 1">
          <i class="el-icon-refresh r-icon r-icon-ref"
             @click="loadPhoneInformation(row.id)"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
          <i class="el-icon-more r-icon r-icon-more" @click="openMorePhone(row[prop])"></i>
        </el-tooltip>
      </div>
    </div>
    <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" append-to-body width="40%" center>
      <template v-slot:title>
        <span class="dia-title">
            更多手机号
        </span>
      </template>
      <div style="text-align: center;">
        <more-phone :options="leftPhone" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PhoneCom from "common/PhoneCom";
import MorePhone from "../../cloudClue/Components/MorePhone.vue";
export default {
  name: 'PhoneInfo',
  components: {MorePhone, PhoneCom },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      leftPhone: []
    }
  },
  methods: {
    call(phone) {
      if (!phone) {
        this.$message.error("手机号为空");
        return;
      }
      this.$axios
        .post("api/admin/call_logs_call", {
          phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
            setTimeout(this.getCallLogs(this.order.customer_phone), 500);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    openMorePhone(phone) {
      this.leftPhone = phone.slice(1);
      this.dialog = true
    },
    closeDialog() {
      this.leftPhone = []
    },
  }
}
</script>
<style lang="stylus" scoped>
.phone-s-r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}
.phone-s {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.phone-a-c {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/PhoneInfo.vue